import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_URL } from '../config';

const SuperAdminLogin = () => {
  const [email,    setEmail]    = useState('superadmin@bhamsa.com');
  const [password, setPassword] = useState('bhamsa@123');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/super-admin/login`,
        { email, password }
      );
      localStorage.setItem('bhamsa_sa_token', res.data.token);
      localStorage.setItem('bhamsa_sa_user', JSON.stringify(res.data.admin));
      toast.success('Welcome Bhamsa Super Admin! 👑');
      window.location.href = '/super-admin/dashboard';
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg)',
      backgroundImage: 'radial-gradient(ellipse at 20% 50%, rgba(108,99,255,0.1) 0%, transparent 60%)',
    }}>
      <div style={{
        background: 'var(--bg2)', border: '2px solid var(--accent)',
        borderRadius: 16, padding: 40, width: '100%', maxWidth: 420,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>👑</div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: 'var(--accent)' }}>
            Bhamsa
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 4 }}>
            Super Admin Panel
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: 12, marginTop: 8 }}
            disabled={loading}
          >
            {loading ? <><span className="spinner-sm" /> Login...</> : '👑 Super Admin Login'}
          </button>
        </form>

       
      </div>
    </div>
  );
};

export default SuperAdminLogin;